import React from 'react';

import Subscribe from 'components/Forms/SubscribeForm';
import LetsTalkFormContainer from 'sections/CustomerStories/LetsTalkFormContainer';

import * as styles from './builder.module.scss';

const Builder = ({ data = [] }) => {
  return (
    <div>
      {data.map((section, i) => {
        switch (section.resourceCenterPostTypeBlock) {
          case 'postSection1':
            return (
              <div
                className={styles.devider}
                key={section.resourceCenterPostTypeBlock + i}
              >
                <Subscribe />
              </div>
            );
          case 'postSection2':
            return (
              <div
                className={styles.devider}
                key={section.resourceCenterPostTypeBlock + i}
              >
                <LetsTalkFormContainer />
              </div>
            );

          default:
            return null;
        }
      })}
    </div>
  );
};

export default Builder;
